import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import '../styles/textWithLink.scss'

const TextWithLink = ({
  text, link, linkTest, className,
}) => (
  <Link to={link} className={`text-with-link ${className}`}>
    {text}&nbsp;<span>{linkTest}</span>
  </Link>
)

TextWithLink.propTypes = {
  text: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  linkTest: PropTypes.string.isRequired,
  className: PropTypes.string,
}

TextWithLink.defaultProps = {
  className: '',
}

export default TextWithLink
